<section id="aprende" class="w-full bg-neutral-gray-900 px-6 py-16">
  <div class="w-full mx-auto">
    <!-- Título de la sección -->
    <div class="flex flex-col gap-2 items-start justify-center text-left mb-8 sm:items-center">
      <h2 class="text-white text-2xl font-poppins font-semibold leading-tight m-0">Aprende con Cantera</h2>
      <p class="text-neutral-gray-400 font-poppins text-base font-normal leading-4 m-0">Contenido para tu crecimiento</p>
    </div>

    <!-- Estados de carga -->
    <div *ngIf="loadingPublicVideos" class="text-sm text-white py-6 text-center">Cargando videos…</div>
    <div *ngIf="!loadingPublicVideos && publicVideos.length === 0"
      class="text-sm text-white py-4 text-center">Sin videos disponibles.</div>

    <!-- Carrusel horizontal de videos -->
    <div class="sm:justify-center flex gap-3 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide pr-6 sm:pr-0"
      *ngIf="!loadingPublicVideos && publicVideos.length > 0">
      <article *ngFor="let video of publicVideos; let i = index"
        class="relative rounded-2xl overflow-hidden bg-black cursor-pointer group flex-shrink-0 snap-start"
        (click)="playPublicVideoByIndex(i, video.multimediaId)" style="width: 250px; height: 400px;">
        <video #publicVideoEl [src]="video.url" 
          class="w-full h-full object-cover" 
          [attr.data-multimedia-id]="video.multimediaId" 
          [attr.data-video-index]="i"
          preload="none" 
          muted 
          playsinline 
          webkit-playsinline 
          [poster]="getVideoPosterUrl(video.multimediaId)"
          (loadedmetadata)="onPublicVideoMetaByIndex(i)"
          (loadeddata)="onPublicVideoMetaByIndex(i)" 
          (canplay)="onPublicVideoMetaByIndex(i)"
          (seeked)="onPublicVideoSeeked(i)"
          (click)="$event.stopPropagation(); togglePublicVideoByIndex(i, video.multimediaId)"></video>

        <!-- Overlay oscuro -->
        <div class="absolute inset-0 bg-black/30 pointer-events-none"></div>

        <!-- Overlay con botón de play -->
        <div *ngIf="!isPublicVideoPlaying(video.multimediaId)"
          class="absolute inset-0 flex items-center justify-center transition-opacity group-hover:bg-black/40 z-20">
          <div
            class="w-16 h-16 rounded-full bg-cantera-red-stepper flex py-4 pr-[15px] pl-[17px] justify-center shadow-lg hover:scale-110 transition-transform">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path d="M8.76495 28.0226C7.85151 28.5935 6.66666 27.9368 6.66666 26.8596L6.66667 5.14171C6.66667 4.06454 7.85151 3.40785 8.76495 3.97875L26.1393 14.8377C26.9987 15.3748 26.9987 16.6265 26.1392 17.1636L8.76495 28.0226Z" fill="white"/>
</svg>
          </div>
        </div>
      </article>

      <!-- Botón Ver más al final del carrusel -->
      <div class="flex items-center justify-center flex-shrink-0 snap-start" style="width: 250px; height: 400px;">
        <button
          class="bg-cantera-red-primary text-white font-poppins p-4 rounded-lg font-bold text-base shadow-xl flex items-center gap-2 hover:bg-[#B71C1A] transition-colors w-[150px] justify-center"
          (click)="openRegisterPromptModal()"
        >
          <span>Ver más</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Espaciador final para asegurar scroll completo -->
      <div class="flex-shrink-0 w-1"></div>
    </div>
  </div>

  <!-- Modal de video fullscreen -->
  <div *ngIf="showFullscreenVideo"
    class="fixed inset-0 z-[9999] bg-black flex items-center justify-center overflow-hidden">
    <!-- Barra de progreso -->
    <div class="fixed top-0 left-0 right-0 w-screen h-[8px] bg-cantera-red-light z-30">
      <div class="h-full bg-cantera-red-stepper transition-all duration-100" [style.width.%]="videoProgress"></div>
    </div>

    <div class="relative w-full h-full max-w-[420px] mx-auto flex items-center justify-center">
      <div class="relative w-full h-full flex items-center justify-center">
        <video #fullscreenVideoEl class="h-full w-auto object-contain" playsinline webkit-playsinline
          style="max-width: 100%; max-height: 100vh;"></video>

        <!-- Overlay oscuro cuando está pausado -->
        <div *ngIf="isVideoPaused"
          class="absolute inset-0 bg-black/50 pointer-events-none z-10 transition-opacity duration-300"></div>
      </div>

      <!-- Controles -->
      <div class="absolute inset-0 flex flex-col justify-between pointer-events-none"
        [class.opacity-0]="!showControls && !isVideoPaused">

        <!-- Barra superior -->
        <div class="flex items-center justify-between p-4 pt-12 w-full">
          <div class="flex items-center gap-3">
            <button type="button"
              class="pointer-events-auto w-5 h-5 flex items-center justify-center text-white relative z-20"
              (click)="$event.stopPropagation(); toggleMute()">
              <svg *ngIf="isMuted" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <path d="M11 5L6 9H2v6h4l5 4V5z" />
                <line x1="23" y1="9" x2="17" y2="15" />
                <line x1="17" y1="9" x2="23" y2="15" />
              </svg>
              <svg *ngIf="!isMuted" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <path d="M11 5L6 9H2v6h4l5 4V5z" />
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
              </svg>
            </button>
          </div>

          <button type="button"
            class="pointer-events-auto w-8 h-8 rounded-full bg-white flex items-center justify-center hover:bg-gray-100 transition relative z-20"
            (click)="$event.stopPropagation(); closeFullscreenVideo()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#20202A" stroke-width="2.5">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Centro: Botón de play cuando está pausado -->
        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20" *ngIf="isVideoPaused">
          <button type="button"
            class="pointer-events-auto w-16 h-16 flex items-center justify-center text-white transition"
            (click)="$event.stopPropagation(); toggleVideoPlayPause()">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor" class="text-white">
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de registro -->
  <div *ngIf="showRegisterModal && showFullscreenVideo"
    class="fixed inset-0 z-[10000] flex items-center justify-center p-4" (click)="closeRegisterModal()">
    <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

    <div class="relative bg-white rounded-2xl shadow-2xl w-[312px] mx-auto" (click)="$event.stopPropagation()">
      <button type="button"
        class="absolute right-4 top-4 w-5 h-5 flex items-center justify-center text-[#0B2C56] hover:opacity-70 transition z-10"
        (click)="closeRegisterModal()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>

      <div class="flex justify-center pt-6 pb-8">
        <img src="assets/img/cantera-blue.svg" alt="CANTERA" class="h-14 w-auto" />
      </div>

      <div class="px-4 pb-6">
        <div class="text-center mb-8">
          <h3 class="text-xl font-extrabold text-[#0B2C56] mb-2 leading-tight">
            Regístrate para continuar viendo
          </h3>
          <p class="text-sm text-slate-600 leading-relaxed">
            Sé parte de la comunidad y aprendiendo sin interrupciones.
          </p>
        </div>

        <div class="space-y-3">
          <button type="button"
            class="w-full h-12 rounded-xl font-extrabold text-white transition-colors hover:opacity-95"
            style="background-color: #D1231E;" (click)="goToRegister()">
            Regístrate gratis
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Modal de Registro/Login -->
<div 
  *ngIf="showQuoteModal"
  class="fixed inset-0 z-[10001] flex items-center justify-center py-6 px-4 bg-black/50"
  (click)="closeQuoteModal()"
>
  <div 
    class="bg-white rounded-3xl w-full max-w-md p-8 relative"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón cerrar -->
    <button
      type="button"
      class="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-neutral-gray-900 hover:bg-neutral-gray-100 rounded-lg transition"
      (click)="closeQuoteModal()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M17.5 16.1667C17.6667 16.3333 17.75 16.5833 17.75 16.8333C17.75 17.0833 17.6667 17.3333 17.5 17.5C17.4167 17.5833 17.3333 17.6667 17.25 17.6667C17.1667 17.75 17 17.75 16.9167 17.75C16.8333 17.75 16.6667 17.75 16.5833 17.6667C16.5 17.5833 16.4167 17.5833 16.3333 17.5L10 11.3333L3.83333 17.5C3.75 17.5833 3.66667 17.6667 3.58333 17.6667C3.33333 17.75 3.08333 17.75 2.83333 17.6667C2.75 17.6667 2.58333 17.5833 2.5 17.5C2.33333 17.3333 2.25 17.0833 2.25 16.8333C2.25 16.5833 2.33333 16.3333 2.5 16.1667L8.66667 10L2.5 3.83333C2.16667 3.5 2.16667 2.91667 2.5 2.5C2.83333 2.16667 3.41667 2.16667 3.83333 2.5L10 8.66667L16.1667 2.5C16.5 2.16667 17.0833 2.16667 17.5 2.5C17.8333 2.83333 17.8333 3.41667 17.5 3.83333L11.3333 10L17.5 16.1667Z" fill="#20202A"/>
</svg>
    </button>

    <!-- Logo -->
    <div class="flex justify-center mb-8">
      <img src="assets/icons/new-logo-cantera.svg" alt="Cantera UNACEM" class="h-20" />
    </div>

    <!-- Título -->
    <h2 class="text-[20px] font-poppins font-semibold text-neutral-gray-900 text-center mb-4">
      Regístrate para continuar
    </h2>

    <!-- Descripción -->
    <p class="text-[14px] font-normal text-neutral-gray-700 font-poppins text-center mb-8">
      Accede a todas las herramientas registrándote gratis o iniciando sesión
    </p>

    <!-- Botones -->
    <div class="flex flex-col gap-2">
      <button
        type="button"
        class="text-[16px] w-full h-14 rounded-xl font-poppins font-bold text-white transition-colors hover:opacity-95 bg-cantera-red-primary"
        (click)="goToRegisterUser()"
      >
        Registrarme gratis
      </button>

      <button
        type="button"
        class="text-[16px] w-full h-14 rounded-xl font-poppins font-bold text-neutral-gray-900 transition-colors hover:bg-neutral-gray-100 border-2 border-neutral-gray-900"
        (click)="goToLogin()"
      >
        Iniciar sesión
      </button>
    </div>
  </div>
</div>
